
import { Component, namespace, Vue } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'

@Component({ components: { OzIcon } })
export default class SurfacePanelShareSectionMainLeave extends Vue {
  @namespace('share').Action confirmCollaboratorLeavePadlet!: () => void
}
